<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.specifications' | trans" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
  </vl-widget-title>

  <div class="flex-row gap-8 ml-md-32 p-4 border-box shrink-0 wrap">
    <vl-chips iconLeft="round_progress_quarter"
              [contentHeight]="true"
              [state]="subType() === widgetSubType.SPECIFICATION_REDIGEE ? 'active' : 'enabled'"
              (action)="subType.set(widgetSubType.SPECIFICATION_REDIGEE)">
      Rédigées
    </vl-chips>
    <vl-chips iconLeft="round_progress_quarter"
              [contentHeight]="true"
              [state]="subType() === widgetSubType.SPECIFICATION_VALIDEE ? 'active' : 'enabled'"
              (action)="subType.set(widgetSubType.SPECIFICATION_VALIDEE)">
      Validées
    </vl-chips>
  </div>
  @if (metadata().loading) {
    <div class="grow overflow-hidden mt-16 ml-md-32">
      <ngx-skeleton-loader count="20" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else {
    <div class="grow list-area">
      <div class="h100 overflow-scroll flex-col gap-12 pl-md-32 mt-16 fade-in">
        @for (elem of specifications(); track $index) {
          <div class="flex-row align-center">
            <div class="flex-col gap-4 grow">
              <div class="flex-row gap-8">
                <span class="body-2 on-background-alt">{{ elem.denomination }}</span>
                <span class="caption on-disabled">{{ 'v' + elem.nbVersion }}</span>
              </div>
              <div class="flex-row gap-8">
                <span class="caption on-background-alt">
                  @switch (this.subType()) {
                    @case (widgetSubType.SPECIFICATION_REDIGEE) {
                      {{ 'widget.dateRedaction' | trans }}:
                    }
                    @case (widgetSubType.SPECIFICATION_VALIDEE) {
                      {{ 'widget.dateValidation' | trans }}:
                    }
                  }
                </span>
                <span class="caption on-disabled">
                  {{ elem.date | date : 'EEE d MMMM' }}
                </span>

              </div>
            </div>
            <mat-icon class="cursor-pointer on-accent" (click)="selectElem(elem)">arrow_forward</mat-icon>
          </div>
        } @empty {
          <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
        }
      </div>

      @if (totalCount() > 0) {
        <vl-chips class="see-all-chip"
                  state="active"
                  size="small"
                  iconRight="open_in_new"
                  (action)="onSeeAll()"
                  matTooltip="Liste complète des spécifications avec recherche, tri et export Excel">
          {{ 'button.see_all' | trans }}
        </vl-chips>
      }
    </div>
  }
</div>
